/**
 * Blank Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('SitesBlankController', [
        '$scope',
        '$window',
        '$timeout',    
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.mapList = function(list) {
                var res = {};
                
                for (var el of list) {
                    res[el] = true;
                }
                
                return res;
            };
            
            $scope.unmapList = function(list) {
                var res = [];
                for (var el in list) {
                    if (list[el]) {
                        res.push(el);
                    }
                }
                
                return res;
            };
            
            $scope.site = {
                orig_site_id: site_id ? site_id : '',
                site_id: site.site_id ? site.site_id : '',
                site: site.site ? site.site : '',
                plan: site.plan ? site.plan : '',
                status: site.status ? site.status : '',
                target_system: site.target_system ? site.target_system : '',
                fw_cname: site.fw_cname ? site.fw_cname : '',
                src_hosts: site.src_hosts ? site.src_hosts.join(',') : '',
                src_security: site.src_security ? site.src_security : '',
                mode: site.mode ? site.mode : '',
                security_level: site.security_level ? site.security_level : '',
                site_user_ids: site_user_ids ? site_user_ids : [],
                
                protection_basic_protect: site.protection_basic_protect ? $scope.mapList(site.protection_basic_protect) : {},
                protection_safe_protect: site.protection_safe_protect ? $scope.mapList(site.protection_safe_protect) : {},
                protection_smart_protect: site.protection_smart_protect ? $scope.mapList(site.protection_smart_protect) : {},
                protection_deep_protect: site.protection_deep_protect ? $scope.mapList(site.protection_deep_protect) : {},
                
                cache_asset_status: site.cache_asset_status ? site.cache_asset_status : '',
                cache_asset_content: site.cache_asset_content ? $scope.mapList(site.cache_asset_content) : {},
                cache_power_status: site.cache_power_status ? site.cache_power_status : '',
                
                xp_httpsec: site.xp_httpsec ? site.xp_httpsec : '',
                xp_protocolsec: site.xp_protocolsec ? site.xp_protocolsec : '',
                xp_blocktrackback: site.xp_blocktrackback ? site.xp_blocktrackback : '',
                xp_blockupload: site.xp_blockupload ? site.xp_blockupload : '',
                xp_blockevasion: site.xp_blockevasion ? site.xp_blockevasion : '',
                xp_blockinvalidcrawler: site.xp_blockinvalidcrawler ? site.xp_blockinvalidcrawler : '',
                xp_blockproxytraffic: site.xp_blockproxytraffic ? site.xp_blockproxytraffic : '',
                
                api_key: site.api_key ? site.api_key : '',
                api_secret: site.api_secret ? site.api_secret : ''
            };                                    
            
            $scope.upsertSite = function() {                                                                                                 
                
                showModalDialog('Please confirm that you are going to save site '+ $scope.site.site_id, function() {
                    var data = {...$scope.site};
                    data.protection_basic_protect = $scope.unmapList(data.protection_basic_protect);
                    data.protection_safe_protect = $scope.unmapList(data.protection_safe_protect);
                    data.protection_smart_protect = $scope.unmapList(data.protection_smart_protect);
                    data.protection_deep_protect = $scope.unmapList(data.protection_deep_protect);
                    data.cache_asset_content = $scope.unmapList(data.cache_asset_content);
                    data.src_hosts = ('' === data.src_hosts) ? [] : data.src_hosts.split(',');
                    
                    $('#loader').parent().show();
                    $('#loader').show();
                    
                    seApi.upsert("sites", JSON.stringify(data)).then(
                        function(data) {                                                        
                            $.alert('success', 'message' in data ? data.message : 'Site was successfully saved', true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                            
                            $window.setTimeout(
                                function() {
                                    $window.location.href = '/#!/se/sites';
                                }, 
                                1500
                            );                          
                        },
                        function(data) {                                                        
                            let error = 'message' in data ? ': '+data.message : '';
                            $.alert('error', 'Error occured'+error, false);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        }
                    );
                });                 
            };
        }
    ]);
})(window.angular);
